var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackToTop = function SvgBackToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F7C144"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7C144",
    d: "M14 19h24v11H14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14 30 12-11 12 11",
    stroke: "#620A15",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

export default SvgBackToTop;